import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Location } from '@angular/common';
import { ApiService } from '../api.service'
import { FilterService } from '../filter.service'
import { UserService } from '../user.service'
import { Course } from '../course.model'
// import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: "app-index",
    templateUrl: "./index.component.html",
    styleUrls: ["./index.component.scss"]
})

export class IndexComponent implements OnInit {

    displayHelpMessage = false
    isLoaded = false
    isLoading = true
    loadingError = false
    courses: Course[] = []
    total: number

    constructor(
        private router: Router,
        private location: Location,
        private apiService: ApiService,
        private filterService: FilterService,
        private userService: UserService,
        // private spinner: NgxSpinnerService
    ) {
        filterService.filter$.subscribe(filters => {
            // this.isLoaded = false
            this.courses = []
            this.getCourses()
        })
    }

    ngOnInit() {
        if ( !this.userService.isAdmin ) {
            this.userService.deny();
            return;
        }

        this.filterService.filters.page = 0;
        this.filterService.filters.type = 'course';
        this.filterService.filters.evaluations = (this.location.path() === '/admin/evaluations')? true : null;
        this.getCourses();
        
    }

    getCourses() {
        this.isLoading = true
        this.filterService.filters.page += 1

        if ( !this.userService.isSuperAdmin && this.filterService.filters.regions.length === 0 ) {
            this.filterService.filters.regions = this.userService.scopedRegions
        }

        this.apiService.getCourses(this.filterService.filters).subscribe(
            data => {
                this.courses = this.courses.concat(data.data.map((course: any) => {return new Course(course)}))
                this.total = data.total
                this.isLoaded = true
                this.isLoading = false
            },
            error => {
                this.loadingError = true
                this.courses = []
                this.isLoaded = true
                this.isLoading = false
            }
        )
    }

    add(){
        this.router.navigate(['/admin/courses-and-events/add'])
    }

    show_reports(){
        this.router.navigate(['/admin/courses-and-events/reports'])
    }

    open(id){
        this.router.navigate([`/admin/courses-and-events/${id}`])
    }

    get isAuthorized(){
        return this.userService.isAuthorized;
    }
}
